import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'

import { User } from '../models/user.entity'

export type UserNotificationCode =
  | GenericNotificationCode
  | 'USER_SAVED'
  | 'USER_DELETED'
  | 'USER_EJECTED'
  | 'USER_INVITED'
  | 'USERS_PERMISSIONS_UPDATED'
  | 'USERS_ROLES_UPDATED'
  | 'TOKEN_CREATED'
  | 'TOKEN_DELETED'
  | 'PASSWORD_UPDATED'

export type UserModalCode = 'USER_DELETION' | 'USER_EJECTION'
/**
 * Parse user notification to a message
 * @param notification - the user notification
 * @returns the notification data
 */
export function parseUserNotification(
  code?: UserNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'USER_SAVED':
      return {
        message: 'User saved successfully',
        color: 'success',
      }
    case 'USER_DELETED':
      return {
        message: 'User deleted successfully',
        color: 'success',
      }
    case 'USER_EJECTED':
      return {
        message: 'User ejected successfully',
        color: 'success',
      }
    case 'USER_INVITED':
      return {
        message: 'User invited successfully',
        color: 'success',
      }
    case 'USERS_PERMISSIONS_UPDATED':
      return {
        message: 'Permissions updated successfully',
        color: 'success',
      }
    case 'USERS_ROLES_UPDATED':
      return {
        message: 'Roles updated successfully',
        color: 'success',
      }
    case 'TOKEN_CREATED': {
      return {
        color: 'success',
        message:
          'API Token created successfully, and copied to memory.\nIt will no longer be visible afterwards',
      }
    }
    case 'TOKEN_DELETED':
      return {
        message: 'Token deleted successfully',
        color: 'success',
      }
    case 'PASSWORD_UPDATED':
      return {
        message: 'Password updated successfully',
        color: 'success',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse goods return code to an modal
 * @param code - the goods return modal code
 * @param user - the goods return object
 * @returns the modal settings
 */
export function parseUserModal(
  code: UserModalCode,
  user?: User,
): DialogOptions {
  switch (code) {
    case 'USER_DELETION': {
      const isHuman = user?.type === 'HUMAN'
      const userName = isHuman
        ? `${user?.name} ${user?.surname}`
        : `${user?.surname}`
      return {
        title: isHuman ? 'Delete user' : 'Delete bot',
        message: isHuman
          ? 'You are about to delete the user <strong>%s</strong>. Proceed with deletion?'
          : 'You are about to delete the bot <strong>%s</strong>. Proceed with deletion?',
        messageParams: [userName],
        buttons: ['Cancel', 'Confirm'],
      }
    }
    case 'USER_EJECTION': {
      const userName = `${user?.name} ${user?.surname}`
      return {
        title: 'Eject user',
        message:
          'You are about to eject the user <strong>%s</strong>. This user will no longer be able to access your tenant. Proceed with ejection?',
        messageParams: [userName],
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
